export const STATUS_CHANGE_ACTIVITY_FIELD_SEPARATOR = '\x1e'

const STATUS_NOTE_FIELD_NAME = 'statusNote'

export function formatStatusChangeActivityName(status, { statusNote = null } = {}) {
  const formattedStatus = typeof status === 'string' ? status.trim() : status
  const formattedStatusNote = typeof statusNote === 'string' ? statusNote.trim() : statusNote
  const fields = []

  if (formattedStatusNote) {
    fields.push(`${STATUS_NOTE_FIELD_NAME}=${formattedStatusNote}`)
  }

  return [formattedStatus, ...fields].join(STATUS_CHANGE_ACTIVITY_FIELD_SEPARATOR)
}

export function parseStatusChangeActivityName(name) {
  const rawName = typeof name === 'string' ? name : ''
  if (!rawName) return { status: null, statusNote: null, fields: {}, rawName }

  const [status, ...encodedFields] = rawName.split(STATUS_CHANGE_ACTIVITY_FIELD_SEPARATOR)
  if (encodedFields.length > 0) {
    const fields = {}
    let statusNote = null

    for (const [index, encodedField] of encodedFields.entries()) {
      const assignmentIndex = encodedField.indexOf('=')

      if (assignmentIndex === -1) {
        if (index === 0) statusNote = encodedField.trim() || null
        continue
      }

      const fieldName = encodedField.slice(0, assignmentIndex).trim()
      const fieldValue = encodedField.slice(assignmentIndex + 1).trim()
      if (!fieldName || !fieldValue) continue

      fields[fieldName] = fieldValue
      if (fieldName === STATUS_NOTE_FIELD_NAME) statusNote = fieldValue
    }

    return { status: status.trim() || null, statusNote, fields, rawName }
  }

  return { status: rawName.trim() || null, statusNote: null, fields: {}, rawName }
}
